<template>
  <div
    class="query-filter-element"
    :class="{ collapsed: collapsed }"
    @mouseenter="active = true"
    @mouseleave="active = false"
  >
    <md-card :class="elevationClass">
      <md-card-header>
        <div :id="id" class="md-title animated">
          {{ title }}
          <gl-button
            v-if="collapsible"
            class="button-collapse"
            icon-button
            style="margin-left: var(--spacing-small); transform: translateY(-4px);"
            @click="toggleCollapse"
          >
            <md-icon v-if="collapsed">expand_more</md-icon>
            <md-icon v-else>expand_less</md-icon>
          </gl-button>
        </div>
      </md-card-header>
      <md-card-content :style="contentStyles">
        <slot></slot>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
/**
 * 分析条件汎用コンポーネント
 */
export default {
  props: {
    /**
     * 分析条件に指定するタイトル
     */
    title: String,
    /**
     * 分析条件サマリクリックにより縦スクロールするためのID
     */
    id: {
      type: String,
      required: true,
    },
    contentWidth: {
      type: String,
      default: 'full',
      validator(v) {
        return ['small', 'medium', 'large', 'full'].includes(v)
      },
    },
    // 折りたたみ可能
    collapsible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
      // 折りたたみ可能な場合、初期は折りたたみ状態
      collapsed: this.collapsible,
    }
  },
  computed: {
    elevationClass() {
      return {
        'md-elevation-4': !this.active,
        'md-elevation-20': this.active,
      }
    },
    /**
     * パネル内コンテンツのスタイル
     */
    contentStyles() {
      let width

      switch (this.contentWidth) {
        case 'small':
          width = 300
          break
        case 'medium':
          width = 500
          break
        case 'large':
          width = 900
          break
      }

      return {
        width: width ? `${width}px` : '100%',
      }
    },
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed
    },
  },
}
</script>

<style lang="scss" scoped>
.query-filter-container {
  padding-left: var(--spacing-medium);
  padding-right: var(--spacing-medium);
}

.query-filter-element {
  &.collapsed {
    .md-card-content {
      display: none;
    }
  }
}

.md-card {
  transition: box-shadow 150ms ease-out;
}
</style>
